import './custom-svg.scss'
import {
    lazy,
    Show,
    createEffect,
    createSignal,
} from 'solid-js'

// TODO: Not sure if this will break production, but need to be addressed in the future
// The glob option "as" has been deprecated in favour of "query". Please update `as: 'component-solid'` to `query: '?component-solid'`.
const svgs = import.meta.glob('/public/assets/**/*.svg', {
    as: 'component-solid',
})

// Cache lazy components to prevent re-creating them on every render
const lazyComponentCache = new Map()

const getLazyComponent = (path) => {
    if (!path) return null

    if (lazyComponentCache.has(path)) {
        return lazyComponentCache.get(path)
    }

    const mappedSvg = svgs[`/public/assets/${path}.svg`]
    if (!mappedSvg) return null

    const lazyComponent = lazy(() => mappedSvg())
    lazyComponentCache.set(path, lazyComponent)
    return lazyComponent
}

const CustomSVG = (props) => {
    const [
        SvgComponent,
        setSvgComponent,
    ] = createSignal(null)

    createEffect(() => {
        setSvgComponent(() => getLazyComponent(props.path))
    })

    return (
        <Show when={SvgComponent()} keyed>
            {(Component) => <Component {...props} />}
        </Show>
    )
}

export default CustomSVG
